import React from "react";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/styles";
import { toJS } from "mobx";
import { withAlert } from "react-alert";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {
  Typography,
  TextField,
  AppBar,
  Button,
  CircularProgress,
  Collapse,
  Box,
  List,
  ListSubheader,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Fade,
  Slide,
  Divider,
  Select,
  MenuItem,
} from "@material-ui/core";
import location from "../../stores/locationStore";
import { FormMenu, detailForm } from "../../components/FormMenu";
import { indigo } from "@material-ui/core/colors";
import user from "../../stores/userStore";
import { Redirect } from "react-router-dom";

import { BrowserRouter as Router } from "react-router-dom";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
const background = indigo[500];
var cloneDeep = require("lodash.clonedeep");
const styles = (theme) => ({
  tableContainer: {
    marginTop: 20,
  },
  item: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  headerTitle: {
    paddingLeft: 10,
  },
  submitBtn: {
    marginTop: 20,
    width: "100%",
  },
  title: {
    marginBottom: 10,
  },
});

const View = observer(
  class Form extends React.Component {
    constructor(props) {
      super(props);
      this.state = { isLoad: true };
    }

    handleChange = async (e) => {
      await this.setState({
        [e.target.name]: e.target.value,
      });
    };
    handleToggle = async (e) => {
      await this.setState({
        [e.target.name]: e.target.checked,
      });
    };
    handleClick = async () => {
      try {
        let data = cloneDeep(this.state);
        delete data.isLoad;
        const USER = toJS(user.user);
        const res = await location.setDetail(
          this.props.match.params.locname,
          data,
          USER
        );
        this.props.alert.show("수정되었습니다.", {
          type: "success",
          actions: [
            {
              copy: "서버로 이동",
              onClick: () => this.props.history.push("/server"),
            },
          ],
        });
      } catch (e) {
        this.props.alert.show(e);
      }
    };

    componentDidMount = async () => {
      await location.getLocationList();
      const detail = toJS(location.getDetail(this.props.match.params.locname));
      var keys = Object.keys(detail);
      keys.forEach((key) => {
        var val = detail[key];
        this.setState({ [key]: val });
      });
      this.setState({ isLoad: false });
      // const menus = location.getDetail(this.props.match.params.locname);
      // menus.map((menu) => {
      //   this.setState({ [menu.title]: menu.val });
      // });
    };

    render() {
      const { classes } = this.props;
      const { locname } = this.props.match.params;
      const blocking = location.blocking;
      const detail = toJS(location.getDetail(this.props.match.params.locname));
      const ignoreArr = ["이창직", "임현수", "전승진"];
      const userList = toJS(user.userList)
        .filter((item) => !ignoreArr.includes(item.username))
        .sort(function (a, b) {
          return a.username < b.username ? -1 : a.username > b.username ? 1 : 0;
        });
      const selectList = ["무방문", "년2회", "년4회", "격월", "종료"];
      const locList = [
        "강원",
        "경기",
        "경남",
        "경북",
        "대구/경북",
        "대전",
        "부산",
        "서울",
        "서울/경기",
        "전남",
        "전북",
        "제주",
        "충청",
        "포항",
      ];
      return (
        <div>
          <Box
            bgcolor={background}
            color="white"
            p={2}
            className={classes.title}
          >
            <KeyboardBackspaceIcon />
            {locname}
            {!this.state.isLoad &&
              Array.isArray(detail) &&
              "은/는 존재하지 않는 기관입니다."}
          </Box>
          {this.state.isLoad && <CircularProgress />}
          <Fade in={!this.state.isLoad && !Array.isArray(detail)}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <Paper>
                    <List subheader={<ListSubheader>Settings</ListSubheader>}>
                      {detailForm
                        .filter((form) => form.view == "setting")
                        .map((menu) => {
                          switch (menu.type) {
                            case "date":
                              return (
                                <div key={menu.title}>
                                  <ListItem>
                                    <div>
                                      <ListItemText primary={menu.title} />
                                      <TextField
                                        id="date"
                                        name={menu.title + "date"}
                                        onChange={this.handleChange}
                                        value={
                                          this.state[menu.title + "date"]
                                            ? this.state[menu.title + "date"]
                                            : ""
                                        }
                                        type="date"
                                      />
                                    </div>
                                    <ListItemSecondaryAction>
                                      <Switch
                                        color="primary"
                                        name={menu.title + "switch"}
                                        checked={
                                          this.state[menu.title + "switch"]
                                            ? this.state[menu.title + "switch"]
                                            : false
                                        }
                                        onChange={this.handleToggle}
                                      />
                                    </ListItemSecondaryAction>
                                  </ListItem>
                                  <Divider />
                                </div>
                              );
                              break;
                            case "text":
                              return (
                                <div key={menu.title}>
                                  <ListItem>
                                    <div>
                                      <ListItemText primary={menu.title} />
                                      <TextField
                                        id="date"
                                        name={menu.title + "text"}
                                        type="text"
                                        value={
                                          this.state[menu.title + "text"]
                                            ? this.state[menu.title + "text"]
                                            : ""
                                        }
                                        onChange={this.handleChange}
                                      />
                                    </div>
                                  </ListItem>
                                  <Divider />
                                </div>
                              );
                              break;
                            default:
                              break;
                          }
                        })}
                    </List>
                  </Paper>
                </Grid>
                <Grid item xs={8}>
                  {detailForm
                    .filter((form) => form.view == "area")
                    .map((menu) => {
                      switch (menu.title) {
                        case "담당":
                          return (
                            <Paper key={menu.title} className={classes.title}>
                              <Box
                                position="static"
                                bgcolor={background}
                                color="white"
                              >
                                <Typography className={classes.headerTitle}>
                                  {menu.title}
                                </Typography>
                              </Box>
                              <div className={classes.item}>
                                <Select
                                  variant="outlined"
                                  margin="normal"
                                  name={menu.title}
                                  label={!this.state[menu.title] && menu.title}
                                  defaultValue={this.state[menu.title]}
                                  value={
                                    this.state[menu.title]
                                      ? this.state[menu.title]
                                      : ""
                                  }
                                  onChange={this.handleChange}
                                >
                                  {userList.map((item) => {
                                    return (
                                      <MenuItem value={item.username}>
                                        {item.username}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </div>
                            </Paper>
                          );
                          break;
                        case "유지보수":
                          return (
                            <Paper key={menu.title} className={classes.title}>
                              <Box
                                position="static"
                                bgcolor={background}
                                color="white"
                              >
                                <Typography className={classes.headerTitle}>
                                  {menu.title}
                                </Typography>
                              </Box>
                              <div className={classes.item}>
                                <Select
                                  variant="outlined"
                                  margin="normal"
                                  name={menu.title}
                                  label={!this.state[menu.title] && menu.title}
                                  defaultValue={this.state[menu.title]}
                                  value={
                                    this.state[menu.title]
                                      ? this.state[menu.title]
                                      : ""
                                  }
                                  onChange={this.handleChange}
                                >
                                  {selectList.map((item) => {
                                    return (
                                      <MenuItem value={item}>{item}</MenuItem>
                                    );
                                  })}
                                </Select>
                              </div>
                            </Paper>
                          );
                          break;
                        case "지역":
                          return (
                            <Paper key={menu.title} className={classes.title}>
                              <Box
                                position="static"
                                bgcolor={background}
                                color="white"
                              >
                                <Typography className={classes.headerTitle}>
                                  {menu.title}
                                </Typography>
                              </Box>
                              <div className={classes.item}>
                                <Select
                                  variant="outlined"
                                  margin="normal"
                                  name={menu.title}
                                  label={!this.state[menu.title] && menu.title}
                                  defaultValue={this.state[menu.title]}
                                  value={
                                    this.state[menu.title]
                                      ? this.state[menu.title]
                                      : ""
                                  }
                                  onChange={this.handleChange}
                                >
                                  {locList.map((item) => {
                                    return (
                                      <MenuItem value={item}>{item}</MenuItem>
                                    );
                                  })}
                                </Select>
                              </div>
                            </Paper>
                          );
                          break;
                        default:
                          return (
                            <Paper key={menu.title} className={classes.title}>
                              <Box
                                position="static"
                                bgcolor={background}
                                color="white"
                              >
                                <Typography className={classes.headerTitle}>
                                  {menu.title}
                                </Typography>
                              </Box>
                              <div className={classes.item}>
                                <TextField
                                  variant="outlined"
                                  margin="normal"
                                  fullWidth
                                  name={menu.title}
                                  label={!this.state[menu.title] && menu.title}
                                  defaultValue={this.state[menu.title]}
                                  value={
                                    this.state[menu.title]
                                      ? this.state[menu.title]
                                      : ""
                                  }
                                  onChange={this.handleChange}
                                  type="text"
                                  multiline
                                />
                              </div>
                            </Paper>
                          );
                          break;
                      }
                    })}
                </Grid>
              </Grid>
              <Button
                variant="contained"
                color="primary"
                size="large"
                className={classes.submitBtn}
                onClick={this.handleClick}
                disabled={blocking}
              >
                등록하기
              </Button>
            </form>
          </Fade>
        </div>
      );
    }
  }
);

const alertView = withAlert()(View);
export default withStyles(styles)(alertView);
